/*
 * nav.ts — sticky-nav shrink-on-scroll and mobile-menu housekeeping.
 * The menu open/close itself is Bootstrap's collapse; this only adds the
 * scrolled state and closes the menu after a link is chosen.
 */

export function initNav(): void {
  const nav = document.querySelector<HTMLElement>(".site-nav");
  if (!nav) return;

  const SHRINK_AT = 80;
  const apply = (): void => {
    nav.classList.toggle("site-nav--scrolled", window.scrollY > SHRINK_AT);
  };
  apply();
  window.addEventListener("scroll", apply, { passive: true });

  const menu = document.getElementById("mainNav");
  if (menu) {
    menu.querySelectorAll<HTMLAnchorElement>("a.nav-link").forEach((link) => {
      link.addEventListener("click", () => menu.classList.remove("show"));
    });
  }
}
